export const GET_CONCEPT_CONFIGURATION = 'GET_CONCEPT_CONFIGURATION'
export const GET_CONCEPT_CONFIGURATION_SUCCESS = 'GET_CONCEPT_CONFIGURATION_SUCCESS'
export const GET_CONCEPT_CONFIGURATION_FAILED = 'GET_CONCEPT_CONFIGURATION_FAILED'

export const DELETE_CONCEPT_CONFIGURATION = 'DELETE_CONCEPT_CONFIGURATION'
export const DELETE_CONCEPT_CONFIGURATION_SUCCESS = 'DELETE_CONCEPT_CONFIGURATION_SUCCESS'
export const DELETE_CONCEPT_CONFIGURATION_FAILED = 'DELETE_CONCEPT_CONFIGURATION_FAILED'
